import { DateTime } from 'luxon';
import React from 'react';

const Rodape = (): React.ReactElement =>
(
    <div className="bg-black p-3 text-muted">
        Copyright {DateTime.now().year} - Enterprise Resource Planning
    </div>
)

export default Rodape;
